// extracted by mini-css-extract-plugin
export default {"container":"ConfirmationModal_container__Kd7yn"};